import config from "../../config";
import makeRequest from "../../makeRequest";

/* Normalised image URL for a Member id. Server returns 404 if no image; UI should fall back. */
export const memberImageUrl = (id) => `${config.api.baseUrl}/website/member/${id}/image`;

/* Rotating gradient palette so cards keep their colourful look without per-row config. */
export const ROLE_PALETTE = [
  "linear-gradient(135deg, #076cec, #04b3bf)",
  "linear-gradient(135deg, #047857, #10b981)",
  "linear-gradient(135deg, #7c3aed, #a855f7)",
  "linear-gradient(135deg, #ff6b35, #f7c948)",
  "linear-gradient(135deg, #1e3a8a, #3b82f6)",
  "linear-gradient(135deg, #be123c, #f43f5e)",
  "linear-gradient(135deg, #0891b2, #22d3ee)",
  "linear-gradient(135deg, #b45309, #f59e0b)",
  "linear-gradient(135deg, #166534, #22c55e)",
];

/* Fetch all teams + members (active rows) from public endpoint. */
export const fetchPublicTeams = async () => {
  try {
    const res = await makeRequest({
      route: "/website/team/public",
      method: "get",
    });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (e) {
    console.error("fetchPublicTeams failed:", e);
    return [];
  }
};

/* Pick the first team whose name matches (case-insensitive, trimmed) any of the supplied aliases. */
export const findTeam = (teams, aliases) => {
  const wanted = aliases.map((a) => a.toLowerCase().trim());
  return teams.find((t) =>
    wanted.includes(
      String(t?.name || "")
        .toLowerCase()
        .trim(),
    ),
  );
};
